import { gray80 } from '../../../colors/gray';
import { palette } from '../palette';
export var MuiPaper = {
    styleOverrides: {
        root: {
            '& .YdsInboxMessageHeader-leadingIcon': {
                backgroundColor: palette.text.secondary,
                color: gray80,
            },
            '& .YdsInboxMessageHeader-leadingIconImportant': {
                backgroundColor: palette.error.main,
            },
        },
    },
};
